import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { CONSTANT } from '../../Constants/EventService'

const DeleteModal = ({ isOpen, onClose, onDelete, eventId, loading }) => {
  const handleCancelClick = () => {
    onClose()
  }
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose()
    }
  }
  const handleDeleteClick = () => {
    onDelete(eventId)
    onClose()
  }

  return (
    <Fragment>
      {isOpen && <div className={`modal-backdrop fade  ${isOpen ? 'show' : ''}`}></div>}
      <div
        className={`modal fade ${isOpen ? 'show' : ''}`}
        id="deletepost"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        style={{ display: isOpen ? 'block' : 'none' }}
        onClick={handleBackdropClick}>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content border-0 pb-0">
            <div className="modal-body text-center">
              <div className="text-center mb-3">
                <img src="/images/delete.png" alt="delete icon" />
              </div>
              <h5 className="text-dark">Cancel {CONSTANT.EVENT}</h5>
              <p>
                Are you sure you want to cancel this {CONSTANT.EVENT}?
                <br className="d-none d-lg-block" />
                This action cannot be undone.
              </p>
              <div className="d-flex mt-5 gap-2">
                <button
                  type="button"
                  className="btn flex-grow-1 btn-border"
                  onClick={handleCancelClick}>
                  Close
                </button>
                <button
                  type="button"
                  disabled={loading}
                  className="btn flex-grow-1 btn btn-danger"
                  onClick={handleDeleteClick}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  eventId: PropTypes.string.isRequired,
}

export default DeleteModal